import { Badge } from "@/components/ui/Badge";
import { formatCount } from "../stages";
import type { Coverage, CoverageStageData } from "../types";
import { CoverageBar } from "./CoverageBar";

type Props = {
  data: CoverageStageData | undefined;
  coverage: Coverage | undefined;
};

/** The final state of each paper, and the check of the papers without rows. */
export const CoverageStage = ({ data, coverage }: Props) => (
  <div className="space-y-3">
    {(data?.complete || coverage?.complete) && (
      <Badge variant="green">Each paper of the master list has a final state</Badge>
    )}
    {coverage && <CoverageBar coverage={coverage} />}
    {data && data.no_rows_sample > 0 && (
      <p className="text-sm text-zinc-700">
        Check of the papers without rows: {formatCount(data.sample_with_rows)} of{" "}
        {formatCount(data.no_rows_sample)} sampled papers had rows.
        {data.note_changed && " The reading note changed, and those papers were read again."}
      </p>
    )}
    {coverage && coverage.cut_papers > 0 && (
      <p className="text-xs text-zinc-600">
        {formatCount(coverage.cut_papers)} papers were longer than the reader reads, so only
        their start was read.
      </p>
    )}
    {!data && !coverage && (
      <p className="text-sm text-zinc-500">This stage starts when the maps are done.</p>
    )}
  </div>
);
